import React, { FC } from 'react'
import { Checkbox } from '@mui/material'

interface TableCheckControlProps {
  id?: number
  page?: number
  checkboxIds?: Record<number, number[]>
  totalItems?: number
  onCheck?: (event: React.MouseEvent<HTMLButtonElement>, page: number) => void
  onCheckAll?: (page: number) => void
  isHeader?: boolean
}

const checkboxIcon = {
  color: '#FFFFFF',
  pointerEvents: 'painted !important',
  opacity: 1,
  '&.Mui-checked': {
    color: '#FFFFFF',
  },
  '&.MuiCheckbox-indeterminate': {
    color: '#FFFFFF',
  },
}

export const TableCheckControl: FC<TableCheckControlProps> = ({
  id,
  page = 1,
  checkboxIds = {} as Record<number, number[]>,
  totalItems = 0,
  onCheck = () => void 0,
  onCheckAll = () => void 0,
  isHeader,
}) => {
  const isChecked = id ? checkboxIds?.[page]?.includes(id) : false
  const isIndeterminate = checkboxIds?.[page]?.length > 0 && checkboxIds?.[page]?.length < totalItems
  const isAllChecked = checkboxIds?.[page]?.length === totalItems

  return (
    <Checkbox
      checked={isHeader ? isAllChecked : isChecked}
      indeterminate={isHeader ? isIndeterminate : false}
      onClick={isHeader ? () => onCheckAll(page) : (event) => onCheck(event, page)}
      data-id={id}
      sx={checkboxIcon}
      inputProps={!isHeader ? { 'aria-labelledby': `enhanced-table-checkbox-${id}` } : {}}
    />
  )
}
